<template>
  <div>
    <div class="course">
      <div class="main">
        <div class="header">
          <ul class="coursebox">
            <li>课程分类:</li>
            <li>
              <el-cascader
                :options="categoryList"
                :props="{ checkStrictly: true }"
                clearable
                @change="categoryClick"
              >
              </el-cascader>
            </li>
          </ul>
        </div>
        <div class="courseList">
          <el-row :gutter="15">
            <el-col :span="8" v-for="(practice,index) in courseDetail" :key="practice.id" >
              <div class="grid-content" @click="courseHandler(practice.id)">
                <el-card :body-style="{ padding: '5px' }" >
                  <div class="warpd">
                    <img :src="GLOBAL.BASE_URL+practice.thum" class="images" >
                  </div>
                  <div class="text clearfix courseInfo">
                    <div class="infor"><p class="p1">{{practice.name}}</p>
                      <p class="p2"><span>{{practice.created_at}}</span><span class="pull-right"> <img class="practiceImage"
                                                                                                       src="../../../static/images/icon.svg" alt="">
                        {{ practice.user_count}}</span><span><img :src="GLOBAL.BASE_URL+practice.category.thum" alt=""
                                                                  class="img"></span></p></div>
                    <div class="score">5.0分</div>
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
          <div style="text-align: right" v-if="pageform.total>pageform.pageSize">
            <el-pagination
              background
              @current-change="pageCurrentChange"
              :page-count="pageform.pages"
              :current-page="pageform.pageNum"
              layout="prev, pager, next"
              :total="pageform.total"
              :page-size="pageform.pageSize"
            >
            </el-pagination>
          </div>

        </div>
      </div>

    </div>

  </div>


</template>

<script>
    export default {

        name: 'Course',

        data() {
            return {
                // 分页插件
                pageform: {
                    total:0,
                    pages: 5,  // 总页数
                    pageNum: 1, // 当前的页码
                    pageSize: 9, // 每页显示条目个数
                },
                params: {
                    page_size: 9,
                    page:1
                },
                courseType: ['在线训练', '模型', '智能设备'],
                categoryList: [],
                myIndex: 0,
                filterList: [
                    {id: 1, title: "默认", query: ''},
                    {id: 2, title: "人气", query: '-learn_number'},
                    {id: 3, title: "价格", query: 'price'},

                ],
                categoryId: 0,
                query: '',
                courseDetail: [],
                count: 0,
                filterIndex: null
            };
        },
        methods: {
            /* 分页插件 */
            // pageNum (当前页数)改变时会触发
            pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
                // console.log('当前页:'+ val);
                this.pageform.pageNum = val;
                this.params.page = val;
                this.chooseCourseAllList();
            },
            courseHandler(courseId) {
                console.log(courseId)
                this.$router.push({
                    path: `/courses/${courseId}/details-introduce`,

                })
            },
            // 筛选排序处理事件
            filterHandler(i, query) {
                this.myIndex = i;
                this.query = query;
                if (this.myIndex === 0) {
                    this.filterIndex = null;
                } else if (this.myIndex === 1) {
                } else if (this.myIndex === 2) {
                    if (this.count % 2 == 0) {
                        this.filterIndex = 0;
                    } else {
                        this.query = '-' + this.query;
                        this.filterIndex = 1;
                    }
                    this.count++;
                }
                this.chooseCourseAllList();
            },
            //课程分类事件操作
            categoryClick(categoryIds) {
                this.params.category_id = categoryIds.slice(-1)[0];
                this.params.page=1;
                this.pageform.pageNum=1;
                this.chooseCourseAllList();
            },
            chooseCourseAllList() {
                if (this.$cookies.get('token')) {
                    this.params.class_id = this.$store.getters.getUserInfo.class_id;
                    this.getCourseList();
                } else
                    this.getCourseAllList();
            },
            // 获取全部的课程列表
            getCourseAllList() {
                this.$http.courseAllList(this.params)
                    .then(res => {
                        if (res.code !== 0) {
                            this.courseDetail = res.data.learn;
                            this.pageform.pages = res.data.allPage;
                            this.pageform.total = res.data.allCount;
                        }else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            // 获取班级课程列表
            getCourseList() {
                this.$http.courseList(this.params)
                    .then(res => {
                        if (res.code !== 0) {
                            this.courseDetail = res.data.learn;
                            this.pageform.pages = res.data.allPage;
                            this.pageform.total = res.data.allCount;
                        }else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            // 获取分类列表
            getCategoryList() {
                this.$http.categoryTree()
                    .then(res => {
                        if (res.code !== 0) {
                            for(var i=0;i<res.data.length;i++){
                                if(res.data[i].label=="口腔类"){

                                }
                                if(res.data[i].label=="临床类"){

                                }
                            }
                            this.categoryList = res.data;
                        }else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
        },
        created() {
            this.getCategoryList();
            this.chooseCourseAllList();
        }
    };
</script>

<style lang="css" scoped>
  .course {
    width: 100%;
    /*background: #f3f3f3;*/
    margin-bottom: 20px;
  }

  .main {
    width: 1200px;
    margin: 0 auto;
    /* padding-top: 35px; */
  }

  .images {
    width: 100%;
    /* height: 200px; */
  }
  .warpd{
    height:220px;
    overflow: hidden;
  }

  .main .header {
    width: 100%;
    height: auto;
    /* margin-bottom: 35px; */
    padding: 25px 0 25px 0;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 #f0f0f0;
  }
  .practiceImage{
    cursor: pointer;
    transition: all 0.6s;
  }
  .practiceImage:hover{
    transform: scale(1.4);
  }
  .coursebox {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #888;
    font-family: PingFangSC-Regular;
    letter-spacing: .36px;
    border-bottom: 1px solid #333;
    border-bottom-color: rgba(51, 51, 51, .05);
    /* padding-bottom: 18px;
    margin-bottom: 17px; */
  }

  .coursebox li {
    padding: 6px 16px;
    line-height: 16px;
    margin-left: 14px;
    position: relative;
    transition: all .3s ease;
    cursor: pointer;
    border: 1px solid transparent;
    color: #4a4a4a;
  }

  .coursebox li.active {
    color: #f5a623;
    border: 1px solid #f5a623 !important;
    border-radius: 30px;
  }

  .filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .filter ul {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #888;
    font-family: PingFangSC-Regular;
    letter-spacing: .36px;
  }

  .filter ul li {
    padding: 6px 16px;
    line-height: 16px;
    margin-left: 14px;
    position: relative;
    transition: all .3s ease;
    cursor: pointer;
    color: #4a4a4a;
  }

  .filter ul li.active {
    color: #f5a623;
  }

  dl {
    list-style: none;
    width: 100%;
    height: auto;
    background: #fff;
    padding: 20px 30px 20px 20px;
    display: flex;
    margin-bottom: 35px;
    border-radius: 2px;
    cursor: pointer;
    box-shadow: 2px 3px 16px rgba(0, 0, 0, .1);
    transition: all .2s ease;
    position: relative;
  }

  dl dt {
    font-weight: 700;
    width: 423px;
    height: 210px;
    margin-right: 30px
  }

  dl dt img {
    width: 100%;
    height: 100%;
  }

  dl dd {
    flex: 1;
    line-height: 1.42857143;
  }

  .courseList dl dd div {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .courseList dl dd .name p {
    display: flex;
    font-size: 14px;
    font-weight: 500;
    color: #9b9b9b;
    font-family: PingFangSC-Light;
  }

  .courseList dl dd .name p:first-child {
    font-size: 26px;
    color: #333;
  }

  .courseList dl dd p img {
    width: 11px;
    margin-right: 7px;
    vertical-align: middle;
  }

  .teacher {
    display: flex;

    align-items: flex-end;
    justify-content: space-between;
    font-size: 14px;
    color: #9b9b9b;
    margin-bottom: 14px;
    padding-bottom: 14px;
    font-family: PingFangSC-Light;
    border-bottom: 1px solid #333;
    border-bottom-color: rgba(51, 51, 51, .05);
  }

  .courseList dl dd ul {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }

  .courseList dl dd ul li {
    width: 49%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;
    margin-bottom: 15px;
    cursor: pointer;
  }

  .courseList dl dd ul li img {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }

  .courseList dl dd ul li p {
    max-width: 227px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-family: PingFangSC-Regular;
  }

  .courseList dl dd ul li span {
    width: 34px;
    height: 20px;
    color: #fd7b4d;
    margin-left: 30px;
    border: 1px solid #fd7b4d;
    border-radius: 2px;
    text-align: center;
    font-size: 13px;
    white-space: nowrap;
  }

  .courseList dl dd ul li:hover {
    color: #f5a623;
  }

  .courseList dl dd .price {
    justify-content: space-between;
    font-family: PingFangSC-Medium;
    margin-top: 7px;
    display: flex;
    align-items: center;
  }

  .courseList dl dd .price span {
    font-size: 24px;
    color: #fa6240;
  }

  .courseList dl dd .price button {
    cursor: pointer;
    outline: none;
    width: 120px;
    height: 38px;
    background: transparent;
    color: #fa6240;
    font-size: 16px;
    border: 1px solid #fd7b4d;
    border-radius: 3px;
    font-family: PingFangSC-Regular;
    transition: all .2s ease-in-out;
  }

  .filter ul li:nth-child(4):before {
    content: "";
    width: 0;
    border: 5px solid transparent;
    border-top-color: #d8d8d8;
    position: absolute;
    right: 0;
    bottom: 2.5px;
  }

  .filter ul li:nth-child(4):after {
    content: "";
    width: 0;
    border: 5px solid transparent;
    border-bottom-color: #d8d8d8;
    position: absolute;
    right: 0;
    top: 2.5px;
  }

  .filter ul li:nth-child(4).change1:after {
    content: "";
    width: 0;
    border: 5px solid transparent;
    border-bottom-color: #f3a536;
    position: absolute;
    right: 0;
    top: 2.5px;
  }

  .filter ul li:nth-child(4).change2:before {
    content: "";
    width: 0;
    border: 5px solid transparent;
    border-top-color: #f3a536;
    position: absolute;
    right: 0;
    bottom: 2.5px;
  }

  .filter p {
    font-family: PingFangSC-Light;
    font-size: 14px;
    color: #9b9b9b;
  }


</style>



// WEBPACK FOOTER //
// src/components/Course/Course.vue